import { render, staticRenderFns } from "./currentNewsItem.vue?vue&type=template&id=14d3db5d&scoped=true&"
import script from "./currentNewsItem.vue?vue&type=script&lang=ts&"
export * from "./currentNewsItem.vue?vue&type=script&lang=ts&"
import style0 from "./currentNewsItem.vue?vue&type=style&index=0&id=14d3db5d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14d3db5d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Users\\its_bas_sp_schramwy\\serviceportal\\RUB.Serviceportal\\ClientApp\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('14d3db5d', component.options)
    } else {
      api.reload('14d3db5d', component.options)
    }
    module.hot.accept("./currentNewsItem.vue?vue&type=template&id=14d3db5d&scoped=true&", function () {
      api.rerender('14d3db5d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/molecules/currentNewsItem.vue"
export default component.exports